import axios from "axios";

export const getStopReasonCodeGroups = async (companyKey) => {
    try {
        const response = await axios.get(`/api/stopReasonCodeGroups/?companyKey=${companyKey}`);
        return response.data;
    } 
    catch (error) {
        throw error.response.data;
    }
}

export const updateStopReasonCodeGroup = async (stopReasonCodeGroup) => {
    try {
      const response = await axios.put(`/api/stopReasonCodeGroups/`, stopReasonCodeGroup);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  };

export const createStopReasonCodeGroup = async (stopReasonCodeGroup) => {
    try {
      const response = await axios.post(`/api/stopReasonCodeGroups/`, stopReasonCodeGroup);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  }

export const deleteStopReasonCodeGroup = async (id) => {
    try {
      const response = await axios.delete(`/api/stopReasonCodeGroups/${id}`);
      return response;
    } catch (error) {
      throw error.response.data;
    }
  }